import createRoute               from '@widesk-ui/tools/createRoute';
import DeliverableBadgeInfoModel from '@models/shop/DeliverableBadgeInfoModel';

export default createRoute.table('/deliverable_badge_infos', 'shop', 'DeliverableBadgeInfoTable', DeliverableBadgeInfoModel.localize('plural'));
